"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class AccordionItemMixin */
/** @method */
var AccordionItemMixin = function AccordionItemMixin(props) {
  return (0, _styledToken.default)({
    borderColor: 'AccordionItem.borderColor',
    borderRadius: 'AccordionItem.borderRadius',
    borderWidth: 'AccordionItem.borderWidth',
    spacing: 'AccordionItem.spacing'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      spacing = _ref.spacing;
    return (0, _styledComponents.css)(["border:", "px solid ", ";border-radius:", "px;&:not(:last-child){margin-bottom:", "px;}"], borderWidth, borderColor, borderRadius, spacing);
  })(props);
};
exports.AccordionItemMixin = AccordionItemMixin;